import * as THREE from 'three';

export const convexMaterial = new THREE.MeshToonMaterial({
  color: 0x00ff00,
  opacity: 0.1,
  transparent: true
});

export const selectedConvexMaterial = new THREE.MeshToonMaterial({
  color: 0xff0000,
  opacity: 0.3,
  transparent: true
});

export const pointsMaterial = new THREE.MeshPhysicalMaterial({
  color: 0x00ff00,
  opacity: 0.3,
  transparent: true
});

export const selectedPointsMaterial = new THREE.MeshPhysicalMaterial({
  color: 0xff0000
});
